export const stylesForBrowserInfoSkeleton = [
  [{ width: "50px", height: "20px" }],
  [{ width: "503px", height: "63px" }],
  [{ width: "50px", height: "20px" }],
  [{ width: "50px", height: "20px" }],
  [{ width: "50px", height: "20px" }],
  [{ width: "50px", height: "20px" }],
  [{ width: "371px", height: "63px" }],
  [{ width: "489px", height: "105px" }],
];
